// LOGIN
const LOGIN_MESSAGE = {
  'ERR-022': '해당 계정은 비활성화 상태입니다.\n고객센터로 문의해 주세요.',
  'ERR-023': '비정상적인 로그인 시도로 인해 회원님의 접속이 제한되었습니다.\n접속 제한을 해제하시려면 고객센터로 문의해 주세요.',//! 페이지 이동
  'ERR-026': '해당 계정은 유효 기간이 만료되었습니다.\n고객센터로 문의해 주세요.',
  'default': '아이디 또는 비밀번호를 잘못 입력하셨습니다.\n입력하신 내용을 다시 확인해 주세요.'
};

const ACCOUNT_VERIFY_EMAIL_MESSAGE = {
  'ERR-102': '이미 등록되어 있는 이메일입니다.',
  'default': '인증 요청 메일을 전송할 수 없습니다.'
};

const VERIFY_FIND_PASSWORD_MESSAGE = {
  'ERR-001': '입력하신 정보를 다시 확인해 주세요.',
  'ERR-004': '입력하신 정보를 다시 확인해 주세요.',
  'ERR-032': '입력하신 정보를 다시 확인해 주세요.',
  'default': '인증 요청 메일을 전송할 수 없습니다.'
};

// ----------------------------------------------------------------------

const MESSAGE: {[key: string]: {[key: string]: string}} = {
  'LOGIN': LOGIN_MESSAGE,
  'ACCOUNT_VERIFY_EMAIL': ACCOUNT_VERIFY_EMAIL_MESSAGE,
  'VERIFY_FIND_PASSWORD': VERIFY_FIND_PASSWORD_MESSAGE
};

const messages = (code: string, request: string) => {
  const message = MESSAGE[request];
  const codes = Object.keys(message);
  return codes.includes(code) ? message[code] : message['default'];
};

export default messages;